import ProgramRewardsList from './program-rewards-list'
import { Text } from '@/components'
import MessageBox from '@/app/components/MessageBox/MessageBox'
import { selectProgramRewardDeviceLimits } from '@/reducers/programsNew'
import { searchableUtilityProgramsCollection } from '@/reducers/utilityPrograms'
import { useAppSelector } from '@/hooks'
import { UtilityProgram } from '@/types/utilityProgram'
import DeviceLimitHelpers from '@/app/pages/multi-program-enrollment/device-selection/DeviceLimitHelpers'
import { useParams } from 'react-router-dom'
import { APIProgramRewardsByCategory } from '@/types/programs-new/programs-new'
import RewardHelpers from '@/app/pages/multi-program-enrollment/rewards/rewardsUtils'
import AlertMessage from '@/app/components/AlertMessage'

type ProgramRewardsListProps = {
  rewardsByCategory: APIProgramRewardsByCategory | null
  /** When provided, use this instead of route param :id (e.g. on pages without :id in the path) */
  utilityProgramId?: number
}

function useProgramRewardsListViewModel(utilityProgramIdOverride?: number) {
  const { id: utilityProgramIdParam } = useParams<{ id: string }>()
  const idFromParams =
    utilityProgramIdParam !== undefined
      ? parseInt(utilityProgramIdParam)
      : undefined
  const utilityProgramId = utilityProgramIdOverride ?? idFromParams

  const { data: utilityPrograms } =
    searchableUtilityProgramsCollection.useFetch({
      path: `utility_programs/${utilityProgramId}`,
      require: Boolean(utilityProgramId),
    })

  const utilityProgram = utilityPrograms?.[0] as UtilityProgram | undefined
  const rewardDeviceLimits = useAppSelector(
    selectProgramRewardDeviceLimits(
      utilityProgram?.id ?? utilityProgramId ?? 0,
    ),
  )
  const limitsText =
    DeviceLimitHelpers.DeviceLimitsAlertText(rewardDeviceLimits)

  return { limitsText }
}

export default function ProgramRewardsListCard(props: ProgramRewardsListProps) {
  const { limitsText } = useProgramRewardsListViewModel(props.utilityProgramId)
  const isExternalReward = RewardHelpers.useExternalPayoutCheck(
    props.utilityProgramId,
  )

  if (!props.rewardsByCategory) return null

  return (
    <div className="w-full flex flex-col gap-4 border rounded-lg border-solid border-themed-grey-100 p-4">
      <Text variant="h3">Program Rewards</Text>
      <ProgramRewardsList rewardsByCategory={props.rewardsByCategory} />
      {limitsText && (
        <div>
          <MessageBox>Rewards only apply for {limitsText}</MessageBox>
        </div>
      )}
      {isExternalReward && (
        <div>
          <AlertMessage variant="info">
            Rewards will be paid outside of Optiwatt by program partner
          </AlertMessage>
        </div>
      )}
    </div>
  )
}
